import React, { createContext, useContext, useState, useEffect } from 'react';
import CustomAlert from '../components/custom/CustomAlert';
import logger from "../utils/logger";

import { messaging } from '../components/lib/FireBaseConfig';
import { onMessage } from 'firebase/messaging';

const AlertContext = createContext();

export const useAlert = () => {
  return useContext(AlertContext);
}

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  // Initialize Firebase Cloud Messaging =====================
  useEffect(() => {
      if (!messaging) return;
  
      const handleNotification = (payload) => {
          logger.log("Notification received: ", payload);
          if (payload?.notification?.body) {
              showAlert({
                  title: payload.notification.title || null,
                  message: payload.notification.body,
                  type: 'danger',
                  buttons: [{ label: 'Close', type: 'primary' }],
              });
          }
      };
  
      const unsubscribe = onMessage(messaging, handleNotification);
  
      return () => {
          unsubscribe();
      };
  }, [messaging]);
  // =======================================================

  const showAlert = ({ title = null, message, type = 'success', buttons }) => {
    setAlert({ title, message, type, buttons });
  };

  const closeAlert = () => {
    setAlert(null);
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {alert && (
        <CustomAlert 
          title={alert.title}
          message={alert.message} 
          type={alert.type} 
          onClose={closeAlert} 
          buttons={alert.buttons} 
        />
      )}
      {children}
    </AlertContext.Provider>
  );
}
